import React, { useState, useEffect, useReducer } from 'react'
import {
  Panel,
  IconButton,
  Icon,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Radio,
  RadioGroup,
  Row,
  Col,
  Input,
  Message,
  Checkbox,
  Grid,
} from 'rsuite'
import { useHistory, useParams } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { getMaxLengthData, isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SingleRadioForm from '../../components/forms/singleRadioForm/SingleRadioForm'
import { saveReviewSend, saveDraftReviewSend, getReviewSend } from '../../redux/actions/reviewSend'
import { startLoading, doneLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import { find } from 'lodash'
import ConfirmWidget from '../confirm/ConfirmWidget'
import COIValidateWidget from '../coi/COIValidateWidget'
import ShowLimitLength from '../../components/utils/ShowLimitLength'

export default function ReviewSummary(props) {
  const [moreComments, setMoreComments] = useState(false)
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors, getValues, reset } =
    useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDraft, setIsShowConfirmDraft] = useState(false)
  const [request, setRequest] = useState()
  const [showSuccess, setShowSuccess] = useState(false)
  const [otherText, setOtherText] = useState()
  
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  useEffect(() => {
    if (formSchema?.summaryResult?.summaryResult?.value == 2) {
      const selected = formSchema?.summaryResult?.summaryResult?.options?.find(
        (item) => item.value == 2
      )
      console.log('selected', selected)
      if (selected.otherOption && selected.otherValue) {
        setMoreComments(true)
      }

      setOtherText(formSchema.summaryResult?.inputSummaryResult?.value)
    }
  }, [formSchema])

  // const onReloadPage = () => {
  //   setIsRefreshSchema(true)
  //   setTimeout(() => {
  //     setIsRefreshSchema(false)
  //   }, 100)
  // }

  // const refreshSchema = async () => {
  //   try {
  //     const res = await getReviewSend(projectId)

  //     if (res.model?.forms?.ReviewForm) {
  //       setValue('issue', null)
  //       setIsRefreshSchema(true)
  //       setFormSchema(res.model?.forms?.ReviewForm)
  //     }
  //   } catch (e) {
  //     console.log('error : ', e)
  //   }
  //   setTimeout(() => setIsRefreshSchema(false), 1000)
  // }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirm(false)
    try {
      const _schema = await saveReviewSend(request)
      doneLoading()
      const _projectVersionId =
        _schema.projectVersionId || _schema.model?.projectVersionId || projectId

      sessionStorage.setItem('projectId', _projectVersionId)
      sessionStorage.setItem('param', '')

      return history.push(`${pathname.proposal.overview.overviewCoworker}`)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallSaveDraft = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmDraft(false)
    setShowSuccess(false)
    try {
      const response = await saveDraftReviewSend(request)
      if (response.success) {
        setShowSuccess(true)
        setFormSchema(response.model?.forms?.ReviewForm)
        reset()
      }
      // const _projectVersionId =
      //   _schema.projectVersionId || _schema.model?.projectVersionId || projectId
      // return history.push(`${pathname.proposal.overview.overviewCoworker}/${_projectVersionId}`)
    } catch (e) {
      console.log('error : ', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    if (data.summaryResult != 2) {
      data.inputSummaryResult = ''
    }

    const issueList = [];
    if(data?.issue) {
      Object.entries(data?.issue).forEach(([key, value]) => {
          const [masterSubjectId, projectFeedbackId] = key.split('_');
          issueList.push({
              projectFeedbackId: projectFeedbackId || null,
              id: masterSubjectId,
              value: value
          });
      });
    }


    let request = {
      projectVersionId: projectId,
      isCOI: checkInterest,
      issue : issueList,
      // issue: {
      //   background: {
      //     id: schema.issue.background.id,
      //     projectFeedbackId: schema.issue.background.projectFeedbackId,
      //     value: data.background,
      //   },
      //   objective: {
      //     id: schema.issue.objective.id,
      //     projectFeedbackId: schema.issue.objective.projectFeedbackId,
      //     value: data.objective,
      //   },
      //   periodAndPlan: {
      //     id: schema.issue.periodAndPlan.id,
      //     projectFeedbackId: schema.issue.periodAndPlan.projectFeedbackId,
      //     value: data.periodAndPlan,
      //   },
      //   targetGroup: {
      //     id: schema.issue.targetGroup.id,
      //     projectFeedbackId: schema.issue.targetGroup.projectFeedbackId,
      //     value: data.targetGroup,
      //   },
      //   budget: {
      //     id: schema.issue.budget.id,
      //     projectFeedbackId: schema.issue.budget.projectFeedbackId,
      //     value: data.budget,
      //   },
      //   monitoring: {
      //     id: schema.issue.monitoring.id,
      //     projectFeedbackId: schema.issue.monitoring.projectFeedbackId,
      //     value: data.monitoring,
      //   },
      //   expectedResult: {
      //     id: schema.issue.expectedResult.id,
      //     projectFeedbackId: schema.issue.expectedResult.projectFeedbackId,
      //     value: data.expectedResult,
      //   },
      //   otherComment: {
      //     id: schema.issue.otherComment.id,
      //     projectFeedbackId: schema.issue.otherComment.projectFeedbackId,
      //     value: data.otherComment,
      //   },
      // },
      summaryResult: {
        id: formSchema.summaryResult.summaryResult.id,
        projectFeedbackId: formSchema.summaryResult.summaryResult.projectFeedbackId,
        value: data.summaryResult,
        otherValue: data.inputSummaryResult,
      },
      commentPublish: {
        id: formSchema.commentPublish.commentPublish.id,
        projectFeedbackId: formSchema.commentPublish.commentPublish.projectFeedbackId,
        value: data.commentPublish,
      },
    }

    console.log('save => ', request)
    setRequest(request)
    setIsShowConfirm(true)
    //handleCallService(request)
  }

  const onSubmitDraft = () => {

    let inputSummaryResult = getValues(formSchema.summaryResult.inputSummaryResult.name)
    if (getValues(formSchema.summaryResult.summaryResult.name) != 2) {
      inputSummaryResult = ''
    }

    console.log('getValues issue=> ', getValues())
    var data = getValues()

    const issueList = [];
    if(data?.issue) {
      Object.entries(data?.issue).forEach(([key, value]) => {
          const [masterSubjectId, projectFeedbackId] = key.split('_');
          issueList.push({
              projectFeedbackId: projectFeedbackId || null,
              id: masterSubjectId,
              value: value
          });
      });
    }

    let request = {
      projectVersionId: projectId,
      isCOI: checkInterest,
      issue: issueList,
      // issue: {
      //   background: {
      //     id: schema.issue.background.id,
      //     projectFeedbackId: schema.issue.background.projectFeedbackId,
      //     value: getValues(schema.issue.background.name),
      //   },
      //   objective: {
      //     id: schema.issue.objective.id,
      //     projectFeedbackId: schema.issue.objective.projectFeedbackId,
      //     value: getValues(schema.issue.objective.name),
      //   },
      //   periodAndPlan: {
      //     id: schema.issue.periodAndPlan.id,
      //     projectFeedbackId: schema.issue.periodAndPlan.projectFeedbackId,
      //     value: getValues(schema.issue.periodAndPlan.name),
      //   },
      //   targetGroup: {
      //     id: schema.issue.targetGroup.id,
      //     projectFeedbackId: schema.issue.targetGroup.projectFeedbackId,
      //     value: getValues(schema.issue.targetGroup.name),
      //   },
      //   budget: {
      //     id: schema.issue.budget.id,
      //     projectFeedbackId: schema.issue.budget.projectFeedbackId,
      //     value: getValues(schema.issue.budget.name),
      //   },
      //   monitoring: {
      //     id: schema.issue.monitoring.id,
      //     projectFeedbackId: schema.issue.monitoring.projectFeedbackId,
      //     value: getValues(schema.issue.monitoring.name),
      //   },
      //   expectedResult: {
      //     id: schema.issue.expectedResult.id,
      //     projectFeedbackId: schema.issue.expectedResult.projectFeedbackId,
      //     value: getValues(schema.issue.expectedResult.name),
      //   },
      //   otherComment: {
      //     id: schema.issue.otherComment.id,
      //     projectFeedbackId: schema.issue.otherComment.projectFeedbackId,
      //     value: getValues(schema.issue.otherComment.name),
      //   },
      // },
      summaryResult: {
        id: formSchema.summaryResult.summaryResult.id,
        projectFeedbackId: formSchema.summaryResult.summaryResult.projectFeedbackId,
        value: getValues(formSchema.summaryResult.summaryResult.name),
        otherValue: inputSummaryResult,
      },
      commentPublish: {
        id: formSchema.commentPublish.commentPublish.id,
        projectFeedbackId: formSchema.commentPublish.commentPublish.projectFeedbackId,
        value: getValues(formSchema.commentPublish.commentPublish.name),
      },
    }

    // console.log('save draft => ', JSON.stringify(request))
    setRequest(request)
    setIsShowConfirmDraft(true)
    //handleCallService(request)
  }

  const renderPanel = (item) => {
    const key = item.projectFeedbackId ? 
      `${item.id}_${item.projectFeedbackId}` 
      : item.id;

    return (
        <Col>
          <div style={{ padding: 4, marginBottom: 20 }}>
            <ControlLabel>
              {requiredFiled(item?.validators, item?.label)}
            </ControlLabel>
            <ErrorMessage error={errors[item?.name]} />
            <br />
            <Input
              name={`issue.[${key}]`}
              inputRef={register(isValidators(item?.validators))}
              rows={3}
              placeholder={item?.placeholder}
              componentClass="textarea"
              style={{ marginTop: 5 }}
              defaultValue={item?.value}
              disabled={schema.issue.disabled}
              maxLength={getMaxLengthData(item?.validators)?.value}
              onChange={() => forceUpdate()}
            />
            <ShowLimitLength
              textLength={getValues(`issue.[${key}]`)?.length || 0}
              maxLength={getMaxLengthData(item?.validators)?.value || 4000}
            />
          </div>
        </Col>)
  }

  return (
    <>
      <Panel
        header={formSchema.subHeader}
        collapsible
        defaultExpanded
        shaded
        bordered
        style={{ marginBottom: '20px' }}
      >
        
        <Panel header={formSchema.issue.label} collapsible defaultExpanded>
          <Row>
            {/*ประเด็นการกลั่นกรองโครงการ แบบฟอร์ม 8 ข้อหลัก  */}
            {formSchema?.issue?.forms?.map((item) => renderPanel(item))}
          </Row>
        </Panel>

        <Panel header={formSchema.summaryResult.label} collapsible defaultExpanded>
          <div style={{ padding: 4, marginBottom: 10 }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.summaryResult.summaryResult.validators,
                formSchema.summaryResult.summaryResult.label
              )}
            </ControlLabel>
            <ErrorMessage error={errors[formSchema.summaryResult.summaryResult.name]} />

            <br />
            <Controller
              name={formSchema.summaryResult.summaryResult.name}
              control={control}
              defaultValue={
                formSchema.summaryResult.summaryResult.value
                  ? parseInt(formSchema.summaryResult.summaryResult.value, 10)
                  : ''
              }
              rules={isValidators(formSchema.summaryResult.summaryResult.validators)}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value),
                        value === 2 ? setMoreComments(true) : setMoreComments(false)
                    }}
                  >
                    {formSchema.summaryResult.summaryResult.options.map((item) => (
                      <>
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={formSchema.summaryResult.disabled}
                      >
                        {item.label}
                      </Radio>

                      {item.value === 2 && moreComments && (
                        <div style={{ padding: 4, marginBottom: 10 }}>
                          <ErrorMessage error={errors[formSchema.summaryResult.inputSummaryResult.name]} />
                          <Input
                            name={formSchema.summaryResult.inputSummaryResult.name}
                            inputRef={register(
                              isValidators(formSchema.summaryResult.inputSummaryResult.validators)
                            )}
                            rows={3}
                            placeholder={formSchema.summaryResult.inputSummaryResult.placeHolder}
                            componentClass="textarea"
                            defaultValue={formSchema.summaryResult.inputSummaryResult.value}
                            disabled={formSchema.summaryResult.disabled}
                            maxLength={getMaxLengthData(formSchema.summaryResult.inputSummaryResult.validators)?.value}
                            onChange={(text) => setOtherText(text)}
                          />
                          <ShowLimitLength
                            textLength={otherText?.length || 0}
                            maxLength={getMaxLengthData(formSchema.summaryResult.inputSummaryResult.validators)?.value || 4000}
                          />
                        </div>
                      )}
                    </>
                    ))}
                  </RadioGroup>
                )
              }}
            />

          </div>
        </Panel>

        <Panel header={formSchema.commentPublish.label} collapsible defaultExpanded>
          <div style={{ padding: 4, marginBottom: 10 }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.commentPublish.commentPublish.validators,
                formSchema.commentPublish.commentPublish.label
              )}
            </ControlLabel>
            <ErrorMessage error={errors[formSchema.commentPublish.commentPublish.name]} />

            <br />
            <Controller
              name={formSchema.commentPublish.commentPublish.name}
              control={control}
              defaultValue={
                formSchema.commentPublish.commentPublish.value
                  ? parseInt(formSchema.commentPublish.commentPublish.value, 10)
                  : ''
              }
              rules={isValidators(formSchema.commentPublish.commentPublish.validators)}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchema.commentPublish.commentPublish.options.map((item) => (
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={formSchema.commentPublish.disabled}
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </div>
        </Panel>

        <br />
        {!formSchema.issue.disabled && (
          <div style={{ paddingLeft: 10 }}>
            {/* <Grid fluid>
              <Row style={{ marginBottom: 10 }}>
                <Checkbox onChange={(value, checked) => setCheckCOI(checked)} checked={checkCOI}>
                  ยืนยันการไม่มีส่วนเกี่ยวข้องโดยตรงกับผู้เสนอโครงการ แล้วจึงจะสามารถกดปุ่มส่ง
                  ตามหลักเกณฑ์และวิธีการจัดสรรเงินเพื่อการสนับสนุนโครงการและกิจกรรม พ.ศ.2550 ข้อ 7.2
                  กำหนดให้กระทำโดยผู้ทรงคุณวุฒิที่ไม่เกี่ยวข้องโดยตรงกับผู้เสนอโครงการ
                </Checkbox>
              </Row>

              <Row style={{ marginBottom: 10 }}>
                <Checkbox onChange={(value, checked) => setCheckCOI(checked)} checked={checkCOI}>
                  มีส่วนได้เสีย
                </Checkbox>
              </Row>
            </Grid> */}

            <COIValidateWidget
              isCOIPass={isCOIPass}
              setIsCOIPass={setIsCOIPass}
              checkCOI={checkCOI}
              setCheckCOI={setCheckCOI}
              setIsCheckCOI={setIsCheckCOI}
              setCheckInterest={setCheckInterest}
              checkInterest={checkInterest}
              fixType={'6'}
            />
          </div>
        )}

        <hr />
        {isError && (
          <div style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
            />
          </div>
        )}
        {showSuccess && (
          <Message closable showIcon type="success" description={'บันทึกร่างข้อคิดเห็นสำเร็จ'} />
        )}

        <IconButton
          appearance="ghost"
          icon={<Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />}
          onClick={handleSubmit(onSubmit)}
          disabled={formSchema.issue.disabled || !checkCOI || !isCOIPass || isLoading}
        >
          บันทึกการส่งข้อคิดเห็น
        </IconButton>

        <IconButton
          style={{ marginLeft: 15 }}
          appearance="ghost"
          icon={<Icon appearance="ghost" icon="save" className="bt-gost-icon-radius" />}
          onClick={onSubmitDraft}
          disabled={formSchema.issue.disabled || isLoading}
        >
          บันทึกร่างข้อคิดเห็น
        </IconButton>
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการบันทึกการส่งข้อคิดเห็น`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการบันทึกการส่งข้อคิดเห็น`}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={() => handleCallService(request)}
      />

      <ConfirmWidget
        title={`ยืนยันการบันทึกร่างข้อคิดเห็น`}
        show={isShowConfirmDraft}
        detail={`กรุณายืนยันการบันทึกร่างข้อคิดเห็น`}
        onCancle={() => setIsShowConfirmDraft(false)}
        onConfirm={() => handleCallSaveDraft(request)}
      />
    </>
  )
}
